import * as React from "react";
const SvgFiRrCampfire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-campfire_svg__a)">
      <path
        fill="#062147"
        d="M23.939 23.342a1 1 0 0 1-1.281.598L12 20.064 1.342 23.94a.999.999 0 0 1-1.281-.598 1 1 0 0 1 .598-1.282L9.074 19 .658 15.94a1 1 0 0 1 .683-1.88l10.658 3.876 10.658-3.876a1 1 0 0 1 .683 1.88L14.925 19l8.415 3.06a1 1 0 0 1 .599 1.282M4.999 9c0-2.065 1.154-3.533 2.283-4.696A1.002 1.002 0 0 1 9 5c.003.273.064.57.139.772.109-.325.22-.795.31-1.173.319-1.34.715-3.005 1.796-4.253a1 1 0 0 1 .72-.345c.3-.015.548.096.743.292.376.375.867.802 1.388 1.254C16.166 3.345 19 5.806 19 9c0 3.629-2.777 6.62-6.316 6.965a3.5 3.5 0 0 1-1.368 0C7.777 15.62 5 12.63 5 9zm6.63 4.962c.125.009.244.038.37.038.129 0 .249-.028.375-.038.25-.065.49-.17.687-.366a1.5 1.5 0 0 0 .439-1.061c0-.401-.156-.777-.44-1.061L12 10.413l-1.061 1.06c-.283.285-.44.66-.44 1.062 0 .4.157.777.44 1.06.196.196.439.302.69.367M6.999 9c0 1.395.579 2.656 1.504 3.564q-.002-.016-.003-.028c0-.935.364-1.814 1.025-2.475l1.768-1.768a1 1 0 0 1 1.414 0l1.768 1.768a3.48 3.48 0 0 1 1.025 2.475q-.002.015-.003.028A4.98 4.98 0 0 0 17 9c0-2.283-2.338-4.312-4.216-5.943q-.307-.265-.597-.52c-.377.774-.594 1.688-.792 2.524C11.05 6.506 10.695 8 9.282 8c-.764 0-1.325-.37-1.7-.915C7.214 7.675 7 8.29 7 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-campfire_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCampfire;
